import axios from 'axios';
import { call, all, put, takeLatest, select } from 'redux-saga/effects';

import * as dailyReportActions from './vendor-client-visit-actions';

import { saveAs } from 'file-saver';

import { GET_LIST_ALL_REQUEST, GET_LIST_SELECTS_REQUEST, SHARE_CSV } from './vendor-client-visit-constants';

import notification from '~/services/notification';
import dailyReportServices from './vendor-client-visit-service';

import { ISA_ERROR, USER_ROLE } from '~/constants';

import { AppStateType } from '../root-reducer';

import { formatDateTime, formatMessage } from '~/i18n/translate';
import { UserInterface } from '@e3labs/isa-data-dictionary';
import { ClientInterface } from '@e3labs/isa-data-dictionary';

let cancel: any;
const CancelToken = axios.CancelToken;

export function* getAllDailyReportReport({
  type,
  payload
}: {
  type: any;
  payload: {
    date: Date[];
    sellers: UserInterface[];
    clients: ClientInterface[];
    type: string;
  };
}) {
  if (cancel !== undefined) cancel();
  const cancelToken = new CancelToken(function executor(c) {
    cancel = c;
  });

  try {
    yield put(dailyReportActions.setLoadingData(true));

    const { rowsPerPage, page, order, orderBy } = yield select((state: AppStateType) => state.vendorClientVisit.list);

    const params = {
      beginDate: payload?.date
        ? payload?.date[0]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      endDate: payload?.date
        ? payload?.date[1]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      usersExternalCode: payload?.sellers?.map(seller => seller.externalCode)?.join(',') ?? '',
      clientsExternalCode: payload?.clients?.map(client => client.externalCode)?.join(',') ?? '',
      skip: page === 0 ? 0 : page * rowsPerPage,
      limit: rowsPerPage,
      order,
      orderBy
    };

    const [{ data: successDailyReports }] = yield all([
      call(
        dailyReportServices.getListSuccessDailyReports,
        {
          ...params
        },
        {
          cancelToken
        }
      )
    ]);

    yield put(
      dailyReportActions.getAllDailyReportReportsSuccess({
        dailyReports: [...successDailyReports]
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(dailyReportActions.setLoadingData(false));
  }
}

export function* getSelects() {
  try {
    yield put(dailyReportActions.setLoadingSelects(true));

    const { data: sellers } = yield call(dailyReportServices.getSellers);

    yield put(
      dailyReportActions.getListSelectsSuccess({
        selects: {
          sellers: sellers?.filter(seller => seller?.userRole === USER_ROLE?.VENDOR)
        }
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(dailyReportActions.setLoadingSelects(false));
  }
}

export function* shareCSV({ payload, exportType }: any) {
  const toast: any = notification.loading(formatMessage('commonLoadingMessage'));

  try {
    const params = {
      beginDate: payload?.date
        ? payload?.date[0]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      endDate: payload?.date
        ? payload?.date[1]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      usersExternalCode: payload?.sellers?.map(seller => seller.externalCode)?.join(',') ?? '',
      clientsExternalCode: payload?.clients?.map(client => client.externalCode)?.join(',') ?? ''
    };

    if (exportType === 'xlsx') {
      let data;

      data = yield call(dailyReportServices.getXslxSuccessDailyReports, params);

      const xlsx = data?.data;

      const blob = new Blob([xlsx], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(blob, `Relatório de Rota Diária -  ${formatDateTime(new Date())}.xlsx`);
    } else {
      let data;

      data = yield call(dailyReportServices.getCSVSuccessDailyReports, params);

      const csv = data?.data;

      const reader = new FileReader();

      const blobFile = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

      reader.readAsDataURL(blobFile);
      reader.onloadend = async function () {
        saveAs(blobFile, `Relatório de Rota Diária - ${formatDateTime(new Date())}.csv`);
      };
    }
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    toast.close();
  }
}

export default all([
  takeLatest(GET_LIST_ALL_REQUEST, getAllDailyReportReport),
  takeLatest(GET_LIST_SELECTS_REQUEST, getSelects),
  takeLatest(SHARE_CSV, shareCSV)
]);
